import { lazy } from 'react'
import { Navigate } from 'react-router-dom'
import SuperAdminLayout from '../layout/superAdminLayout'
import LazyLoad from './utils/LazyLoad'
import RequireUserTypeAuth from './utils/requireUserTypeAuth'
const Dashboard = LazyLoad(lazy(() => import('../pages/superAdmin/dashboard')))
const BusinessManagement = LazyLoad(lazy(() => import('../pages/superAdmin/businessManagement')))
const UserManagement = LazyLoad(lazy(() => import('../pages/superAdmin/userManagement')))
const CustomerManagement = LazyLoad(lazy(() => import('../pages/superAdmin/customerManagement')))
const Settings = LazyLoad(lazy(() => import('../pages/superAdmin/configuration')))
const ViewAll = LazyLoad(lazy(() => import('../features/_superAdmin/dashboard/viewAll')))
const CustomerPage = LazyLoad(
  lazy(() => import('../pages/superAdmin/customerManagement/customerPage')),
)
const BusinessDetailsPage = LazyLoad(lazy(() => import('../pages/superAdmin/businessDetailsPage')))
const SuperAdminRoutes = {
  path: '/super-admin',
  element: (
    <RequireUserTypeAuth authorizedUserType={'super_admin'}>
      <SuperAdminLayout />
    </RequireUserTypeAuth>
  ),

  children: [
    {
      path: '',
      element: <Navigate to='dashboard' />,
    },
    {
      path: 'dashboard',
      element: <Dashboard />,
    },
    {
      path: 'dashboard/view-all',
      element: <ViewAll />,
    },

    {
      path: 'business-management',

      element: <BusinessManagement />,
    },
    {
      path: 'user-management',

      element: <UserManagement />,
    },
    {
      path: 'configuration',

      element: <Settings />,
    },
    {
      path: 'customers',

      element: <CustomerManagement />,
    },
    {
      path: 'customers/:id',
      element: <CustomerPage />,
    },
    // for testing business details page for now, will remove after api deployed
    {
      path: 'business-details',
      element: <BusinessDetailsPage />,
    },
    {
      path: 'business-details/:id',
      element: <BusinessDetailsPage />,
    },
  ],
}
export default SuperAdminRoutes
